// Whether a group belongs in this editor at all.
//
// A group may carry `visible`: false, or a function asked with the editing
// context. The tab strip is built from the answer, so a group a document has
// no use for is not shown at all (rather than shown and empty).
//
// The rules run above the editor — before the type's section providers mount —
// so whatever they need beyond the document is loaded by a `visibilityContext`
// hook of the type. The hooks are a fixed list while a model is applied (the
// composer settles them once), which is what lets them be called in a loop.

/** The context the visibility rules are asked with, extended by the type's hooks. */
export function useVisibilityContext(contentType, base) {
  let context = base
  for (const useExtraContext of contentType?.visibilityContexts || []) {
    context = { ...context, ...(useExtraContext(context) || {}) }
  }
  return context
}

export const isGroupVisible = (group, context) => {
  if (typeof group?.visible === "function") return group.visible(context) !== false
  return group?.visible !== false
}
